import { useEffect, useState } from "react";
import _ from "lodash";
import PouchDB from "pouchdb-browser";
import { useDoc } from "use-pouchdb";
import { useRecoilValue } from "recoil";
import Container from "@mui/material/Container";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import DownloadIcon from "@mui/icons-material/ImportExport";
import { currentQuestionnaire, current, stores } from "./../../utilities/state";

const localDB = new PouchDB('delfornoqsc', { revs_limit: 1 });

function StoreSelector(props) {

    const { handleStoreChange } = props;
    const _stores = useRecoilValue(stores);
    const _current = useRecoilValue(current);
    const _currentQuestionnaire = useRecoilValue(currentQuestionnaire);
    const [store, setStore] = useState('');
    const [comment, setComment] = useState('');
    const [manager, setManager] = useState('');
    const { doc, loading } = useDoc(_current);

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    };

    const handleManagerChange = (event) => {
        setManager(event.target.value);
    };

    const saveCommentChange = () => {
        doc.comment = comment;
        localDB.put(doc);
    };

    const saveManagerChange = () => {
        if (doc && !loading) {
            doc.manager = manager;
            localDB.put(doc);
        }
    };

    const handleChange = (event) => {
        let storeId = event.target.value;
        setStore(storeId);
        let store = _.find(_stores, { 'storeId': storeId });
        handleStoreChange(store);
    };

    useEffect(() => {
        if (doc && !loading) {

            if (doc.comment) {
                setComment(doc.comment);
            }
            if (doc.manager) {
                setManager(doc.manager);
            }

            setStore(doc.storeId);
        }
    }, [doc, loading, store, _current])

    const importQSC = () => {

        var input = document.createElement('input');
        input.type = 'file';

        input.onchange = e => {

            var file = e.target.files[0];
            var reader = new FileReader();
            reader.readAsText(file, 'UTF-8');

            reader.onload = readerEvent => {
                var content = readerEvent.target.result;
                let parsed = JSON.parse(content);
                processImport(parsed);
            }
        }

        input.click();
    }

    const processImport = async (data) => {

        console.log(data)

        localDB.get(data._id).then((doc) => {
            console.log('found', doc)
        }).catch((err) => {
            if (err.status === 404) {
                localDB.put(data);
            }
        });

         
        // if (!found) {


        //     let _qscs = [];

        //     _qscs.push(data.qscs[0]);

        //     _.each(doc.qscs, (qsc) => {
        //         _qscs.push(qsc);
        //     })

        //     await localDB.upsert('audits', (doc) => {
        //         doc.qscs = _qscs;
        //         return doc;
        //     });

        // } else {

        //     let _qscs = [];

        //     _.each(doc.qscs, (qsc) => {
        //         if (qsc.storeId === found.storeId) {
        //             qsc = data.qscs[0];
        //             _qscs.push(qsc);
        //         } else {
        //             _qscs.push(qsc);
        //         }
        //     })

        //     await localDB.upsert('audits', (doc) => {
        //         doc.qscs = _qscs;
        //         return doc;
        //     });

        //     console.log('result = ', doc)

        // }

    }

    return (
        <Container sx={{ marginTop: 2, paddingTop: 2 }}>
            <Box sx={{ flexGrow: 1, padding: 1, display: 'flex', flexDirection: 'row' }}>
                <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">Franchise</InputLabel>
                    <Select value={store} label="Franchise" onChange={handleChange}>
                        {
                            _stores && _stores.map((store, index) => {
                                return <MenuItem value={store.storeId} key={index}>{store.storeName}</MenuItem>
                            })
                        }
                    </Select>
                </FormControl>
                <Box item xs={12} md={2}>
                    <IconButton size="small" edge="start" color="inherit" aria-label="menu" onClick={() => importQSC()}>
                        <DownloadIcon />
                    </IconButton>
                </Box>
            </Box>
            {
                store !== '' &&
                <>
                    <Box sx={{ margin: 1, marginTop: 2 }}>
                        <TextField label="Manager on Duty" value={manager} onChange={handleManagerChange} onBlur={saveManagerChange} style={{ width: '100%' }} />
                    </Box>
                    <Box sx={{ margin: 1, marginTop: 2 }}>
                        <TextField label="General Comments" multiline maxRows={3} value={comment} onChange={handleCommentChange} onBlur={saveCommentChange} style={{ width: '100%' }} />
                    </Box>
                </>
            }
        </Container>
    )
}

export default StoreSelector
